import { render, staticRenderFns } from "./ShareWedsiteUrlModal.vue?vue&type=template&id=71b0adaf&scoped=true&"
import script from "./ShareWedsiteUrlModal.vue?vue&type=script&lang=js&"
export * from "./ShareWedsiteUrlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0adaf",
  null
  
)

export default component.exports